<template>
  <div v-bind="$attrs">
    <el-dialog
      v-model="dialogVisible"
      title=""
      width="800px"
      :show-close="false"
      :close-on-click-modal="false"
      modal-class="coming-soon-dialog"
      destroy-on-close
      @close="handleClose"
    >
      <!-- Custom Header -->
      <template #header>
        <div class="flex justify-between items-center px-10 py-4 bg-white text-[#004879] rounded-t-[10px]">
          <div class="flex items-center gap-1">
            <span class="font-semibold text-[16px] leading-normal text-[#004879]">Feature Coming Soon ...</span>
          </div>
          <button class="bg-transparent border-none p-0 cursor-pointer w-7 h-7" @click="handleClose">
            <img src="@/assets/MyPatient/close_black.svg" alt="Close" class="w-full h-full" />
          </button>
        </div>
      </template>

      <!-- Dialog Content -->
      <div class="py-6 px-10 bg-[#F9FBFD]">
        <!-- Side by side layout -->
        <div class="coming-soon-dialog-layout">
          <!-- Left side - Text content -->
          <div class="coming-soon-text-content w-1/2">
            <h1 class="coming-soon-main-title">We are building...</h1>
            <h2 class="coming-soon-sub-title">Feature Coming Soon</h2>
          </div>
          
          <!-- Right side - Image -->
          <div class="coming-soon-image-content w-1/2">
            <img src="@/assets/MyPatient/ComingSoon.png" alt="Coming Soon" class="coming-soon-image" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'update:visible'],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style>
.coming-soon-dialog .el-dialog {
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 10px;
  --el-dialog-padding-primary: 0px !important;
}

.coming-soon-dialog .el-dialog__body {
  padding: 0;
}

.coming-soon-dialog-layout {
  display: flex;
  align-items: center;
  gap: 40px;
  min-height: 540px;
}

.coming-soon-text-content {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.coming-soon-image-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coming-soon-image {
  max-width: 90%;
  object-fit: contain;
}

.coming-soon-main-title {
  font-family: "IBM Plex Sans Hebrew", sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  color: #004879;
  margin: 0 0 8px 0;
}

.coming-soon-sub-title {
  font-family: "IBM Plex Sans Hebrew", sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  color: #004879;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .coming-soon-dialog :deep(.el-dialog) {
    width: 90% !important;
    margin: 5vh auto !important;
  }
  
  .coming-soon-dialog-layout {
    flex-direction: column;
    gap: 24px;
    min-height: auto;
  }
  
  .coming-soon-text-content {
    text-align: center;
    order: 2;
  }
  
  .coming-soon-image-content {
    order: 1;
  }
  
  .coming-soon-image {
    max-height: 180px;
  }
  
  .coming-soon-main-title {
    font-size: 24px;
    line-height: 32px;
  }
  
  .coming-soon-sub-title {
    font-size: 18px;
    line-height: 24px;
  }
}
</style>